import { legendEvent, tooltipEvent } from '../common/events/chart-events';
export const donutChartEvents = {
  tooltip: tooltipEvent,
  legend: legendEvent
};